import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "astrobin-presentation-controls",
  templateUrl: "./presentation-controls.component.html",
  styleUrls: ["./presentation-controls.component.scss"]
})
export class PresentationControlsComponent {
  @Input() isPaused: boolean;
  @Input() currentIndex: number;

  @Output() playPause = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  @Output() settings = new EventEmitter<void>();
  @Output() exit = new EventEmitter<void>();
}
